import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "@/index.css";
import App from "@/App";
import { initCapacitor } from "@/lib/capacitor";

/*
 * Capacitor is mainly required for native/mobile environments.
 * Do not allow a Capacitor initialization error to prevent
 * the web application from rendering.
 */
try {
  initCapacitor();
} catch (error) {
  console.warn("Capacitor initialization skipped:", error);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Application root element "#root" was not found in index.html.'
  );
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);